import React, { useEffect, useMemo, useState } from "react";
import logo from "../../assets/images/logo-1.png";
import { Sidebar } from "primereact/sidebar";
import { Link, NavLink } from "react-router-dom";
import { AiOutlineShoppingCart, AiOutlineMenu } from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa";
import { BsMessenger } from "react-icons/bs";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { readCart } from "../../lib/cart";
import Cart from "../Home/Cart";
import MobileSideMenu from "./MobileSideMenu";

const navItems = [
  { to: "/", label: "হোম" },
  { to: "/all-products", label: "শপ" },
  { to: "/borka", label: "বোরকা" },
  { to: "/hijab", label: "হিজাব" },
  { to: "/gallery", label: "গ্যালারী" },
  { to: "/reviews", label: "রিভিউ" },
  { to: "/tutorials", label: "টিউটোরিয়াল" },
  { to: "/track-order", label: "অর্ডার ট্র্যাক" },
];

export default function Navbar() {
  const [user] = useAuthState(auth);
  const [cartVisible, setCartVisible] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [cartCount, setCartCount] = useState(readCart().length);

  useEffect(() => {
    const syncCart = () => setCartCount(readCart().length);
    window.addEventListener("storage", syncCart);
    window.addEventListener("cart-change", syncCart);
    return () => {
      window.removeEventListener("storage", syncCart);
      window.removeEventListener("cart-change", syncCart);
    };
  }, []);

  const isAdmin =
    typeof window !== "undefined" &&
    window.localStorage.getItem("role") === "admin";
  const mobileLinks = useMemo(() => navItems, []);

  return (
    <header className="sticky top-0 z-50 border-b border-black/5 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-4 lg:px-8">
        <button
          className="inline-flex lg:hidden"
          onClick={() => setMenuVisible(true)}
          aria-label="মেনু খুলুন"
        >
          <AiOutlineMenu className="h-6 w-6 text-slate-900" />
        </button>
        <Sidebar
          visible={menuVisible}
          onHide={() => setMenuVisible(false)}
          position="left"
          className="w-[22rem]"
        >
          <MobileSideMenu
            items={mobileLinks}
            onNavigate={() => setMenuVisible(false)}
          />
        </Sidebar>

        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo}
            alt="ইসলামিক পোশাক"
            className="h-11 w-11 rounded-2xl object-contain shadow-sm"
          />
          <div>
            <div className="brand-serif text-2xl font-bold leading-none text-slate-950">
              ইসলামিক পোশাক
            </div>
            <div className="text-[11px] font-semibold uppercase tracking-[0.26em] text-emerald-700">
              কালেকশন
            </div>
          </div>
        </Link>

        <nav className="ml-6 hidden flex-1 items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-md font-semibold transition ${
                  isActive
                    ? "bg-emerald-50 text-emerald-800"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          {user && isAdmin ? (
            <Link
              to="/dashboard"
              className="rounded-full bg-slate-900 px-4 py-2 text-md font-semibold text-white transition hover:bg-slate-700"
            >
              ড্যাশবোর্ড
            </Link>
          ) : null}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          {!user ? (
            <Link
              to="/login"
              className="floating-pill hidden sm:inline-flex text-lg"
            >
              লগইন
            </Link>
          ) : null}
          <a
            href="https://wa.me/+8801918090266"
            target="_blank"
            rel="noreferrer"
            className="floating-pill hidden sm:inline-flex text-md"
          >
            <FaWhatsapp className="h-4 w-4 text-emerald-700" />
            হোয়াটসঅ্যাপ
          </a>
          <a
            href="https://www.facebook.com/islamiposhak"
            target="_blank"
            rel="noreferrer"
            className="floating-pill hidden sm:inline-flex text-md"
          >
            <BsMessenger className="h-4 w-4 text-sky-600" />
            মেসেঞ্জার
          </a>
          <button
            onClick={() => setCartVisible(true)}
            className="relative rounded-full bg-slate-900 p-3 text-white transition hover:bg-emerald-700"
            aria-label="কার্ট খুলুন"
          >
            <AiOutlineShoppingCart className="h-5 w-5" />
            {cartCount > 0 ? (
              <span className="absolute -right-1 -top-1 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-amber-400 px-1 text-[11px] font-bold text-slate-900">
                {cartCount}
              </span>
            ) : null}
          </button>
        </div>

        <Sidebar
          visible={cartVisible}
          onHide={() => setCartVisible(false)}
          position="right"
          className="w-full sm:w-[28rem]"
        >
          <Cart visibleRight={cartVisible} setVisibleRight={setCartVisible} />
        </Sidebar>
      </div>
    </header>
  );
}
